import React from 'react';
import styles from './notFound.module.scss';
import notFound from './undraw_page_not_found_re_e9o6.svg';
import { Typography } from '@mui/material';

export const NotFoundPage = () => {
  return (
    <div className={styles.container}>
      <Typography variant="h5" textAlign="center">
        Стараница не найдена
      </Typography>
    </div>
  );
};
